import {useCallback, useState} from 'react';

const initial = () => ({
    type: 'include',
    ids: new Set(),
});
// custom hook to simplify working with DataGrid
export function useSelectionModel(items = [], idField = 'id') {
    const [selectionModel, setSelectionModel] = useState(initial);

    const clearSelection = useCallback(() => {
        setSelectionModel(initial);
    }, [setSelectionModel]);

    const getSelectedIds = useCallback(() =>
            selectionModel.type === 'include' ?
                Array.from(selectionModel.ids) :
                items.filter((item) => !selectionModel.ids.has(item[idField])).map((item) => item[idField])
        , [items, idField, selectionModel]);

    const getSelectedItems = useCallback(() => {
        const ids = getSelectedIds();
        return items.filter((item) => ids.includes(item[idField]));
    }, [getSelectedIds, items, idField]);

    return {
        selectionModel,
        setSelectionModel,
        clearSelection,
        getSelectedIds,
        getSelectedItems,
        isEmpty: selectionModel.type === 'include' ? selectionModel.ids.size === 0 : selectionModel.ids.size === items.length,
    };
}
